import Operator from './operator';
var none;
none = function () {
    return {
        operator: Operator.none,
    };
};
export default none;
